/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';
import MainContainer from '../components/MainContainer';
import StylesContext from '../context/StylesContext';
import StyledContainer from '../components/StyledContainer';
import StyledTitle from '../components/StyledTitle';
import menuItemsProps from '../interfaces/MenuItemProps';
import MenuItem from '../components/MenuItem';
import NavButtons from '../components/NavButtons';
import VideoContext from '../context/VideoContext';
import VideoPlayer from '../components/VideoPlayer';
import BackButton from '../components/Buttons/BackButton';
import StyledImage from '../components/StyleImage';

interface paramsProps {
  menu: string;
  category: string;
};

const MenuItems = () => {
  const { menu, category } = useParams<paramsProps>();
  const [items, setItems] = useState<Array<menuItemsProps>>();
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const { styles, setStyles } = useContext(StylesContext);
  const { isVideo, videoSrc, setIsVideo } = useContext(VideoContext);

  const handleNext = () => {
    if (items?.length) {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
    };
  };

  const handlePrev = () => {
    if (items?.length) {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + items.length) % items.length);
    }
  };

  const handleBackBtn = () => {
    setIsVideo(false);
  }

  useEffect (() => {
    const getData = async () => {
      try {
        const { data } = await api.get(`menu_itens/category/?url_id=${menu}&category_name=${category}`);
        setItems(data);
      } catch(error: any) {
        console.error(error.message);
      }
    };
    getData();
  }, []);
  
  useEffect(() => {
    const getStyles = async () => {
      try {
        const { data } = await api.get(`menu_styles/${menu}`);
        setStyles(data);
      } catch(error: any) {
      console.error(error.message);
      }
    }
    getStyles();
  }, [menu]);
  
  return (
    <MainContainer className='menu_items_main_container' $backgroundColor={styles.bgColor}>
      {
        items?.length ? (
          !isVideo ? (
            <>          
            <StyledContainer className='menu_items_container_title_icon'>
              <StyledContainer className='category_item_name_container'>
                <img src={ items && items[0].category_icon } alt='icone da categoria' />
              </StyledContainer>
              <StyledTitle
                className='title_menu_items'
                $textColor={styles.textColor}
              >
                {category.toUpperCase()}
              </StyledTitle>
            </StyledContainer>
            {
              items?.length && (
                <>
                  <MenuItem menu_item={items[currentIndex]} handleNext={handleNext} handlePrev={handlePrev} />
                </>
              )
            }
            <NavButtons className='nav_buttons_container' />
            </>
          ) : (
            <StyledContainer className='video_player_menu_item_wrapper'>
              <StyledContainer className='video_player_back_btn'>
                <BackButton onClickFunc={handleBackBtn} color={styles.btnBgColor} className='back_btn_video_player' />
                <StyledContainer className='logo_video_player_wrapper'>
                  <StyledImage src={ styles?.logoImg } className='video_player_logo'/>  
                </StyledContainer>
              </StyledContainer>
              <StyledContainer className='video_player_wrapper_full'>
                <VideoPlayer src={ videoSrc } autoPlay={true} controls={true}/>
              </StyledContainer>
            </StyledContainer>
          )
        ) : (
          <>
            <h2>Nenhum item nessa categoria.</h2>
          </>
        )
      }
      
    </MainContainer>
  )
}

export default MenuItems;